/** The status of one question of a query, straight from the server's `status` column (#262). */
export const QUERY_QUESTION_STATUSES = {
  open: "OPEN",
  answered: "ANSWERED",
  unknownConfirmed: "UNKNOWN_CONFIRMED",
  withdrawn: "WITHDRAWN",
} as const;

export type QueryQuestionStatus = (typeof QUERY_QUESTION_STATUSES)[keyof typeof QUERY_QUESTION_STATUSES];

/** The labels of mock screen 4. */
export const QUERY_QUESTION_STATUS_LABELS: Record<QueryQuestionStatus, string> = {
  [QUERY_QUESTION_STATUSES.open]: "Open",
  [QUERY_QUESTION_STATUSES.answered]: "Answered",
  [QUERY_QUESTION_STATUSES.unknownConfirmed]: "Unknown (confirmed)",
  [QUERY_QUESTION_STATUSES.withdrawn]: "Withdrawn",
};
